"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

require("./button.scss");

var nama_icon_1 = require("../nama-icon");

var ButtonTypes;

(function (ButtonTypes) {
  ButtonTypes["primary"] = "primary";
  ButtonTypes["secondary"] = "secondary";
  ButtonTypes["warning"] = "warning";
  ButtonTypes["flat"] = "flat";
})(ButtonTypes || (ButtonTypes = {}));

exports.ButtonTypes = ButtonTypes;

var Button = function Button(_a) {
  var type = _a.type,
      text = _a.text,
      disabled = _a.disabled,
      onClick = _a.onClick,
      iconLeft = _a.iconLeft,
      iconRight = _a.iconRight,
      async = _a.async;
  return react_1["default"].createElement("button", {
    onClick: !async ? onClick : undefined,
    className: "nama-button " + type + (async ? ' async' : ''),
    disabled: Boolean(disabled)
  }, async && react_1["default"].createElement(nama_icon_1.NamaIcon, {
    icon: "Loading",
    className: "spin loading"
  }), iconLeft && react_1["default"].createElement(nama_icon_1.NamaIcon, {
    icon: iconLeft,
    className: iconRight ? '' : 'only-left'
  }), text && react_1["default"].createElement("p", null, text), iconRight && react_1["default"].createElement(nama_icon_1.NamaIcon, {
    icon: iconRight,
    className: iconLeft ? '' : 'only-right'
  }));
};

exports.Button = Button;
Button.defaultProps = {
  type: ButtonTypes.primary,
  async: false
};